// extracted by mini-css-extract-plugin
export var subtitle = "_bb-2";
export var title = "_bb-0";
export var titleNoWrap = "_bb-1";